module.exports = __webpack_public_path__ + "assets/fonts/Logout-1.d2f0dd7f.svg";